/**
 * @generated SignedSource<<8535d8d9f01aefeafa8af502bef74902>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type storyCardCarouselItemArticle$data = {
  readonly images: ReadonlyArray<{
    readonly alt: string | null;
    readonly isSlideshow: boolean | null;
    readonly resized: {
      readonly url: string | null;
    } | null;
  } | null> | null;
  readonly publishedDate: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "storyCardCarouselItemArticle";
};
export type storyCardCarouselItemArticle$key = {
  readonly " $data"?: storyCardCarouselItemArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"storyCardCarouselItemArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "storyCardCarouselItemArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": {
              "exclude": null
            }
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSlideshow",
          "storageKey": null
        },
        {
          "alias": "resized",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "134w_portrait"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": "style(filter:{\"style\":\"134w_portrait\"})"
        }
      ],
      "storageKey": "images(filter:{\"type\":{\"exclude\":null}})"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "ed5cb570548a7112fddad7758a5a74cf";

export default node;
